import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, MessageService, FormsUtilsService, Task, TaskService } from '../../../../../../core';
import { DatepickerComponent } from '../../../../../../shared/components/datepicker';
import { TituloReceberIntegracaoImportFilter } from '../../../titulo-receber-integracao-import-filter';
import { TituloReceberIntegracaoErpImportHttpService } from '../titulo-receber-integracao-erp-import-http.service';
import { TituloReceberIntegracaoErpImportService } from '../titulo-receber-integracao-erp-import.service';
import { Integracao, IntegracaoErpHttpService } from '../../../../../integracao';

@Component({
    selector: 'sgt-titulo-receber-integracao-erp-import-modal',
    templateUrl: './titulo-receber-integracao-erp-import-modal.component.html',
    styleUrls: ['./titulo-receber-integracao-erp-import-modal.component.less']
})
export class TituloReceberIntegracaoErpImportModalComponent implements OnInit {
    filter: TituloReceberIntegracaoImportFilter;
    elModal: any;

    @ViewChild('form') form: NgForm;
    @ViewChild('datePickerDataEmissaoInicial') datePickerDataEmissaoInicial: DatepickerComponent;
    @ViewChild('datePickerDataEmissaoFinal') datePickerDataEmissaoFinal: DatepickerComponent;
    @ViewChild('datePickerDataVencimentoInicial') datePickerDataVencimentoInicial: DatepickerComponent;
    @ViewChild('datePickerDataVencimentoFinal') datePickerDataVencimentoFinal: DatepickerComponent;
    integracoes: Integracao[];

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private formsUtilsService: FormsUtilsService,
                private taskService: TaskService,
                private integracaoErpHttpService: IntegracaoErpHttpService,
                private tituloReceberIntegracaoErpImportService: TituloReceberIntegracaoErpImportService,
                private tituloReceberIntegracaoErpImportHttpService: TituloReceberIntegracaoErpImportHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.filter = new TituloReceberIntegracaoImportFilter();
                this.searchIntegracoes();
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    /** Pesquisa as integrações ativas do tipo ERP */
    private searchIntegracoes() {
        try {
            this.integracoes = [];
            this.integracaoErpHttpService.searchAtivas()
                .subscribe(
                    integracoes => {
                        this.integracoes = integracoes;
                        if (this.integracoes?.length === 1) {
                            this.filter.idIntegracao = this.integracoes[0].id;
                            jQuery(this.elModal).find('#importModalCodigoIntegracao').trigger('focus');
                        } else {
                            jQuery(this.elModal).find('#importModalIntegracao').trigger('focus');
                        }
                    },
                    (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as integrações ativas do tipo ERP', error)
                );
        } catch (error) {
            this.messageService.error('Erro ao pesquisar as integrações ativas do tipo ERP', 'Erro', error);
        }
    }

    /** Obtem a integração informa no array de integrações */
    private getIntegracao(id: number): Integracao {
        return this.integracoes?.find(integracaoFilter => integracaoFilter.id === id);
    }

    private clear() {
        this.filter = null;
    }

    open() {
        this.clear();
        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Realiza validação do filtro da importação */
    private validateImport(): boolean {
        this.formsUtilsService.makeAllFieldsDirty(this.form);

        // Data de Emissão
        if (this.filter.dataEmissaoInicial && !this.filter.dataEmissaoFinal) {
            this.messageService.warning('Para importar os títulos a receber é necessário informar a data de emissão final quando a data de emissão inicial estiver sido informada', 'Filtro Inválido');
            this.datePickerDataEmissaoFinal.setFocus();
            return false;
        } else if (!this.filter.dataEmissaoInicial && this.filter.dataEmissaoFinal) {
            this.messageService.warning('Para importar os títulos a receber é necessário informar a data de emissão inicial quando a data de emissão final estiver sido informada', 'Filtro Inválido');
            this.datePickerDataEmissaoInicial.setFocus();
            return false;
        }

        // Data de Vencimento
        if (this.filter.dataVencimentoInicial && !this.filter.dataVencimentoFinal) {
            this.messageService.warning('Para importar os títulos a receber é necessário informar a data de vencimento final quando a data de vencimento inicial estiver sido informada', 'Filtro Inválido');
            this.datePickerDataVencimentoFinal.setFocus();
            return false;
        } else if (!this.filter.dataVencimentoInicial && this.filter.dataVencimentoFinal) {
            this.messageService.warning('Para importar os títulos a receber é necessário informar a data de vencimento inicial quando a data de vencimento final estiver sido informada', 'Filtro Inválido');
            this.datePickerDataVencimentoInicial.setFocus();
            return false;
        }

        // Form Inválido
        if (this.form.invalid) {
            this.messageService.warning('Para importar os títulos a receber é necessário informar corretamente o filtro', 'Filtro Inválido');
            return false;
        }

        return true;
    }

    /** Realiza a importação */
    import() {
        if (!this.validateImport()) {
            return;
        }

        const integracao = this.getIntegracao(this.filter.idIntegracao);
        const nomeIntegracao = integracao?.nome ?? '';
        const task = new Task(`Importando os títulos a receber do ERP ${nomeIntegracao}`, `Realizando importação dos títulos a receber do ERP ${nomeIntegracao}`);
        this.taskService.add(task, task.description);
        this.tituloReceberIntegracaoErpImportHttpService.importMany(this.filter)
            .subscribe(
                (response: any) => {
                    this.taskService.success(task, `Importação dos títulos a receber do ERP ${nomeIntegracao} realizada com sucesso`);
                    this.tituloReceberIntegracaoErpImportService.emitAfterImport();
                },
                (error: ApiError) => {
                    this.taskService.error(task, error.message, error.cause, error);
                }
            );

        this.close();
    }
}
